export const FILES_TYPES = [
    { id: 1, name: 'Фото накладной SPARK' },
    { id: 21, name: 'Фото накладной заказчика' },
]
